import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSeverity = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M21.9073 9.87514C22.6664 11.19 22.6664 12.81 21.9073 14.1249L18.7943 19.5171C18.0351 20.8321 16.6321 21.6422 15.1137 21.6422H8.88635C7.36793 21.6422 5.96486 20.8321 5.20568 19.517L2.09274 14.1249C1.33363 12.81 1.33363 11.19 2.09274 9.87514L5.20568 4.48301C5.96486 3.168 7.36793 2.35791 8.88635 2.35791L15.1137 2.35791C16.6321 2.35791 18.0351 3.168 18.7943 4.48301L21.9073 9.87514Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.2 15.6003C12.8628 15.6003 13.4001 16.1375 13.4001 16.8003C13.4001 17.4631 12.8628 18.0003 12.2 18.0003C11.5373 18.0003 11 17.4631 11 16.8003C11 16.1375 11.5373 15.6003 12.2 15.6003ZM12.2 6C12.857 6 13.3841 6.54282 13.3648 7.19951L13.181 13.4477C13.1654 13.9782 12.7308 14.4002 12.2 14.4002C11.6693 14.4002 11.2347 13.9782 11.2191 13.4477L11.0353 7.19951C11.016 6.54282 11.5431 6 12.2 6Z",
		fill: "currentColor"
	})]
});
export default SvgSeverity;
